import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NavController } from "@ionic/angular";

import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { MessagesService } from "src/app/_services/messages.service";
import { PusherService } from "src/app/_services/pusher.service";
import { LocalStorageService } from "../../_services/localStorage.service";
@Component({
  selector: "app-conversation-users",
  templateUrl: "./conversation-users.component.html",
  styleUrls: ["./conversation-users.component.scss"],
  standalone: false,
})
export class ConversationUsersComponent implements OnInit {
  userId: any;
  role: any;
  @Input() usersList: any[] = [];
  @Input() searchQuery: string = "";
  @Output() searchText: EventEmitter<string> = new EventEmitter<string>();
  unreadConversations: any[] = [];
  private unsubscribe$ = new Subject<void>();

  constructor(
    private navController: NavController,
    private localStorageService: LocalStorageService,
    private localStorageServices: LocalStorageService,
    private translate: TranslateService,
    private pusherServices: PusherService,
    private messagesService: MessagesService,
    private router: Router
  ) {
    this.role = this.localStorageServices.getUserRole();
    this.userId = this.localStorageServices.getUserData().client.id;
    this.realTimeMessage();
  }

  ngOnInit() {
    this.getUnreadConversations();
  }

  goBack() {
    this.navController.pop();
  }
  removeUnreadConversation(data: any) {
    this.messagesService.removeUnreadConversation(data);
    let convId = data.other.id;
    const indexToUpdate = this.usersList.findIndex(
      (user) => user.other.id === convId
    );
    this.usersList[indexToUpdate].is_read = 1;
  }
  goTo(path: string, user?: any) {
    let baseUrl = "";
    switch (this.role) {
      case "client":
        baseUrl = "particulier";
        break;
      case "prestataire":
        baseUrl = "prestataire";
        break;
    }
    if (path === "messagerie") {
      this.removeUnreadConversation(user);
      this.navController.navigateForward([
        "/" + baseUrl + `/messagerie/${user.other.id}`,
      ],
      {
        state: {
          conversatinName: user.other.first_name + " " + user.other.last_name,
          guest: false,
        }
      }
    );
    } else {
      this.navController.navigateForward(["/" + baseUrl + "/" + path]);
    }
  }
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const diffInDays = Math.ceil(
      Math.abs(today.getTime() - date.getTime()) / (1000 * 3600 * 24)
    );

    if (this.isSameDay(date, today)) {
      return "Aujourd'hui";
    } else if (this.isSameDay(date, yesterday)) {
      return "Hier";
    } else if (diffInDays < 30) {
      return `Il y a ${diffInDays} jours`;
    } else if (diffInDays < 365) {
      const diffInMonths = Math.floor(diffInDays / 30);
      return `Il y a ${diffInMonths} mois`;
    } else {
      const diffInYears = Math.floor(diffInDays / 365);
      return `Il y a ${diffInYears} ans`;
    }
  }

  private isSameDay(date1: Date, date2: Date): boolean {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
  handleSearch(data: any) {
    let payload = data.target.value;
    this.searchText.emit(payload);
  }
  realTimeMessage() {
    this.messagesService.getRealtimeMessages().subscribe((message: any) => {
      let userDate = {
        message: message.message,
        updated_at: new Date(),
        sender: message.sender,
      };
      this.updateMessages(userDate);
    });
  }
  getUnreadConversations() {
    this.messagesService.getUnreadConversations().subscribe((conv: any) => {
      this.unreadConversations = conv;
    });
  }
  updateMessages(message: any) {
    const indexToUpdate = this.usersList.findIndex(
      (user) => user.other.id === message.sender.id
    );
    if (indexToUpdate !== -1) {
      const updatedConversation = {
        ...this.usersList[indexToUpdate],
        message: message.message,
        updated_at: message.updated_at,
        is_read: 0,
      };
      this.usersList.splice(indexToUpdate, 1);
      this.usersList.unshift(updatedConversation);
    } else {
      this.usersList.unshift({
        message: message.message,
        updated_at: message.updated_at,
        sender: message.sender,
        other: message.sender,
        is_read: 0,
        reciever: null,
      });
    }
    const indexToUpdate2 = this.usersList.findIndex(
      (user) => user.is_read === 0
    );
    this.messagesService.setUnreadConversation([
      this.usersList[indexToUpdate2],
    ]);
  }
}
